import {Utils} from './Utils'

export interface ResponsiveConfig {
    container: HTMLElement;
    list: HTMLElement;
    dropdown: HTMLElement;
    trigger?: HTMLElement;
}

export class Responsive {
    protected visibleWidth: number;
    protected readonly elements: {
        container: HTMLElement;
        list: HTMLElement;
        dropdown: HTMLElement;
        trigger?: HTMLElement;
    };

    constructor({container, list, dropdown, trigger}: ResponsiveConfig) {
        this.elements = {container, list, dropdown, trigger};
        this.init();
    }

    public noSpace(): boolean {
        let availableWidth = (this.getAvailableSpace() < 0) ? 0 : this.getAvailableSpace();
        return (this.visibleWidth > availableWidth);
    }

    public getAvailableSpace(): number {
        return Utils.getInnerWidth(this.elements.container);
    }

    public recalculate(): void {
        const {container, list, dropdown, trigger} = this.elements;
        let noSpace = this.noSpace();

        list.style.display = (noSpace) ? `none` : `flex`;
        dropdown.style.display = (noSpace) ? `block` : `none`;
        container.style.borderLeftWidth = (noSpace) ? `0px` : `1px`;

        if (trigger && trigger.classList.contains('no-dropdown')) {
            !noSpace
                ? trigger.classList.add(`is-disabled`)
                : trigger.classList.remove(`is-disabled`);
        }
    }

    protected bindResizeEvent(): void {
        let animationFrame: number;

        window.addEventListener('resize', (evt) => {
            if (!animationFrame) {
                animationFrame = evt && requestAnimationFrame(() => {
                    animationFrame = null;
                    this.recalculate();
                });
            }
        });
    }

    protected init(): void {
        const {list} = this.elements;
        if (!list) return;

        this.visibleWidth = Utils.getOuterWidth(list);
        this.recalculate();
        this.bindResizeEvent();
    }
}